import React, { useState } from "react";
import {
  Box,
  Text,
  Container,
  VStack,
  Input,
  Textarea,
  Button,
  FormControl,
  FormErrorMessage,
  useToast,
} from "@chakra-ui/react";

import axios from "axios";
import { Link } from "react-router-dom";
const ContactInfoCard = ({ title, children }) => (
  <Box mb={4}>
    <Text fontWeight="bold" mb={2}>
      {title}
    </Text>
    {children}
  </Box>
);


const Maps = (props) => (
  <a
    href="https://www.google.com/maps?q=13483+78+Ave+Surrey+BC+Canada"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="/map.png"
      alt="Google Map"
      style={{
        width: "100%",
        height: "400px",
        objectFit: "cover",
        borderRadius: "8px", // rounded corners
        cursor: "pointer" // pointer on hover
      }}
      {...props}
    />
  </a>
);



export const ContactUs = () => {
  const [formName, setFormName] = useState("");
  const [formEmail, setFormEmail] = useState("");
  const [formNumber,setFormNumber]=useState("");
  const [formMessage, setFormMessage] = useState("");
  const [errors, setErrors] = useState({});
  const toast = useToast();

  const validate = () => {
    let newErrors = {};

    if (!formName.trim()) {
      newErrors.name = "Full name is required";
    }
    if (!formEmail.trim()) {
      newErrors.email = "Email is required";
    }
    else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formEmail)
    ) {
      newErrors.email = "Please enter a valid email";
    }

     if (!formNumber.trim()) {
      newErrors.number = "number required";
    }

    if (!formMessage.trim()) {
      newErrors.message = "Message cannot be empty";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;

  }

const handleSubmit = async (e) => {
  e.preventDefault();

  if (validate()) {
    const data = {
      name: formName,
      email: formEmail,
      number: formNumber,
      message: formMessage,
    };

    try {
      const res = await axios.post("https://lionsforgecontracting.ca/backend/index.php", data,

           { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.status === "success") {
        toast({
          title: "Message sent!",
          description: "We’ll get back to you shortly.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        // Reset form inputs
        setFormName("");
        setFormEmail("");
        setFormNumber("");
        setFormMessage("");
        setErrors({});
      } else {
        toast({
          title: "Error",
          description: res.data.message || "Something went wrong.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (err) {
      console.error(err);
      toast({
        title: "Error",
        description: "Something went wrong while sending your message.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  } else {
    toast({
      title: "Error",
      description: "Please fix the errors before submitting.",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  }
};


  return (
    <Box bg="gray.100" minH="100vh">
      {/* Hero Banner */}
     <Box
  position="relative"
  h="500px"
  bgImage="url('/1.png')"
  bgSize="cover"
  bgPosition="center"
  display="flex"
  alignItems="center"
  justifyContent="center"
  mb={10}
>
  {/* Dark overlay */}
  <Box position="absolute" inset={0} bg="blackAlpha.600" />

  {/* Styled heading */}
  <Box textAlign="center" position="relative" zIndex={1}>
    <Text
      bgGradient="linear(to-r, #B67300, #FFD580)"
      bgClip="text"
      fontSize={{ base: "4xl", md: "6xl" }}
      fontWeight="extrabold"
      textTransform="uppercase"
      letterSpacing="wide"
    >
      Contact Us
    </Text>
    <Box
      mt={3}
      mx="auto"
      w="80px"
      h="3px"
      bg="#B67300"
      borderRadius="full"
    />
  </Box>
</Box>

      {/* Main Content */}
      <Container maxW="1200px" px={{ base: 4, md: 8 }}>
        <Text
          fontSize={{ base: "2xl", md: "3xl" }}
          fontWeight="bold"
          textAlign="center"
          mb={10}
        >
         Contact Us
        </Text>

        <Box
          display={{ base: "block", md: "flex" }}
          gap={6}
          mb={16}
          boxShadow="lg"
          bg="white"
          borderRadius="md"
          overflow="hidden"
        >
          {/* Contact Info */}
          <Box
            flex={1}
            p={8}
            borderRight={{ base: "none", md: "1px solid" }}
            borderBottom={{ base: "1px solid", md: "none" }}
            borderColor="gray.200"
          >
            <Text fontWeight="bold" fontSize="xl" mb={6}>
              GET IN TOUCH - 24/7
            </Text>
            <ContactInfoCard title="Call Us">
              <Text> +1 (604) 712-5656
              </Text>
              
            </ContactInfoCard>

            {/* <ContactInfoCard title="Address">
              <Text>13483 78Ave, Surrey BC, Canada</Text>
            </ContactInfoCard> */}
          </Box>

          {/* Form */}
          <Box id="contact-form" flex={1} p={8}>
            <Text fontWeight="bold" fontSize="xl" mb={6}>
              What are you looking for?
            </Text>
            <form onSubmit={handleSubmit}>
              <VStack spacing={4}>
                <FormControl isInvalid={errors.name}>
                  <Input
                    placeholder="Full Name"
                    value={formName}
                    onChange={(e) => setFormName(e.target.value)}
                  />
                  <FormErrorMessage>{errors.name}</FormErrorMessage>
                </FormControl>

                <FormControl isInvalid={errors.email}>
                  <Input
                    type="email"
                    placeholder="Email"
                    value={formEmail}
                    onChange={(e) => setFormEmail(e.target.value)}
                  />
                  <FormErrorMessage>{errors.email}</FormErrorMessage>
                </FormControl>

                   <FormControl isInvalid={errors.email}>
                  <Input
                    type="number"
                    placeholder="Phone Number"
                    value={formNumber}
                    onChange={(e) => setFormNumber(e.target.value)}
                  />
                  <FormErrorMessage>{errors.number}</FormErrorMessage>
                </FormControl>

                <FormControl isInvalid={errors.message}>
                  <Textarea
                    placeholder="Your message "
                    rows={6}
                    value={formMessage}
                    onChange={(e) => setFormMessage(e.target.value)}
                  />
                  <FormErrorMessage>{errors.message}</FormErrorMessage>
                </FormControl>

                <Button
                  type="submit"
                  bg="orange.500"
                  color="white"
                  _hover={{ bg: "orange.600" }}
                  px={6}
                  fontWeight="medium"
                >
                  SEND MESSAGE
                </Button>
              </VStack>
            </form>
          </Box>
        </Box>

        {/* Map */}
        {/* Map Section */}
        {/* Full Width Map */}

        {/* <Box mb={8} rounded="4px" width="100%" mt={8}>
  <Maps style={{ border: 0, width: "100%", height: "400px" }} />
</Box> */}

      </Container>

    </Box>
  );
};
